import React from 'react'
import { useTranslation } from 'react-i18next'
import { StepDescription } from 'pages/Verification/_components/StepDescription'

export const CorporateStructure = () => {
  const { t } = useTranslation()

  return (
    <>
      <StepDescription
        paragraphs={[
          t('verification.corporateStructure.description.sectionInformation'),
          t('verification.corporateStructure.description.importance'),
          t('verification.corporateStructure.description.checkDetails'),
        ]}
      />
    </>
  )
}
